var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff6B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 104.77 156.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232323;}.cls-2{fill:#093853;}.cls-3{fill:#495e68;}.cls-4{fill:#5c7581;}.cls-5{fill:#4a5f6a;}.cls-6{fill:#0b4f7d;}.cls-7{fill:#1f69ad;}.cls-8{fill:#0d5279;}.cls-9{fill:#ceedf9;}.cls-10{fill:#bbe4f1;}.cls-11{fill:#f3b892;}.cls-12{fill:#51290a;}.cls-13{fill:#8a8d9b;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "ManOnChair_01a",
    "data-name": "ManOnChair_01a",
    viewBox: "0 0 104.77 156.36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.82,118.81l-.52,0c-1.66-.09-6.83-.35-8.84-.24-2.41.14-3.62,1.74-1.74,3.08a61.65,61.65,0,0,0,6.86,3.8c3.4,1.63,7,3,8,2.27,2.75-1.79-.06-9.41-.06-9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.74,118s-1.8-32.42-2.14-36.25,1.2-8,6-8.7a24.68,24.68,0,0,1,14.31,2.55c4.68,2.27,30,12,32,14.71s.26,10.7-3.35,11.77-34.64-14-34.64-14-1.65,26.7-1.74,29.29-.67,4.41-4.41,4.41S32.4,120.82,31.74,118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.3,132.56a1.19,1.19,0,0,0-.6-1l-1.7-1a3.52,3.52,0,0,0-2.85-.3L31,148.19a1.19,1.19,0,0,0-.83,1.23c0,.37,0,1.86,0,2.35a1.16,1.16,0,0,0,.6,1l1.54.89a3.85,3.85,0,0,0,3.16.33l55-17.88A1.19,1.19,0,0,0,91.3,135C91.29,134.56,91.3,133.05,91.3,132.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.28,152.24a1.12,1.12,0,0,0-.58-1L43.14,128.38a3.3,3.3,0,0,0-2.69-.29l-1.52.5a1.13,1.13,0,0,0-.79,1.11c0,.37,0,1.93,0,2.39a1.14,1.14,0,0,0,.57,1l39.4,22.74a3.75,3.75,0,0,0,3,.33l1.32-.44a1.12,1.12,0,0,0,.8-1.1C83.28,154.26,83.27,152.7,83.28,152.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.73,150.37l1.54.89a3.93,3.93,0,0,0,3.16.33l55-17.88a1.21,1.21,0,0,0,.23-2.19l-1.7-1a3.52,3.52,0,0,0-2.85-.3L31,148.19A1.2,1.2,0,0,0,30.73,150.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.48,153.31l-1.32.44a3.75,3.75,0,0,1-3-.33l-39.4-22.74a1.16,1.16,0,0,1,.22-2.1l1.52-.49a3.3,3.3,0,0,1,2.69.29L82.7,151.22A1.15,1.15,0,0,1,82.48,153.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64,131.39c-.06-.55-.67-1.09-1.77-1.43a7.57,7.57,0,0,0-5.6.45,1.28,1.28,0,0,0-.69,1h0v0h0l0,9.68c.06.55.67,1.09,1.77,1.43a7.62,7.62,0,0,0,5.6-.44,1.31,1.31,0,0,0,.69-1h0v0h0v-9.68Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 59.96,
    cy: 131.43,
    rx: 1.79,
    ry: 4.04,
    transform: "translate(-72.11 189.97) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.37,116.22c0-.33-.4-.65-1.06-.86a4.57,4.57,0,0,0-3.36.27.74.74,0,0,0-.41.59h0v14.58c0,.33.4.65,1.06.85A4.52,4.52,0,0,0,62,131.4a.74.74,0,0,0,.41-.59h0V116.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.66,105.85A3.21,3.21,0,0,0,92,103.09L68.34,89.42A12.83,12.83,0,0,0,58,88.33L26.76,98.48a3,3,0,0,0-2.08,3c0,.89,0,3.9,0,4.85a3,3,0,0,0,1.51,2.59l24,13.83A13.46,13.46,0,0,0,61,123.84L91.4,114a3.25,3.25,0,0,0,2.26-3.11C93.67,110,93.68,106.79,93.66,105.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.14,117.79,26.18,104a3,3,0,0,1,.58-5.48L58,88.33a12.83,12.83,0,0,1,10.36,1.09L92,103.09a3.28,3.28,0,0,1-.62,6L61,118.93A13.42,13.42,0,0,1,50.14,117.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,132.72c-8.58,0-13.51-.4-13.78,1.07s-.94,3.35,5,5.22,15.31,3.51,17.12,2.81.8-9,.8-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.2,88.71s-20.53-7-25.68-8.82-13-1.29-13.91,5.75.13,42.53,0,45.21,2.3,3.83,4.41,4.41,8.43,1.21,7.76-3.07-.27-33-.27-33c12.71,9.63,27.16,17.39,33.58,16.32s19.93-5.22,23.14-7.9,4.68-13,4.81-17.52S52.2,88.71,52.2,88.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.44,32.94c4.81-.67,9.36,1.2,10.57,5.35s2.61,26.57,1.33,28.49-16.18,2.67-16.18,2.67L80.83,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M52.74,42.17c5.33-5.34,9.42-6.77,17.39-9.23s14-1.21,16.18-.27,6.44,3.73,6.69,8-1,17.64-2.41,27.43S88.25,85.55,87.65,89c-1.36,7.67-7.9,9.25-16.22,10.44s-17.06-1.52-20-3.35S51.3,74,51.13,68.78,49.66,45.24,52.74,42.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M78.28,28.12l.41,3.48.4,2.94a26.7,26.7,0,0,1-6.69,1.2,14.9,14.9,0,0,1-6.82-1.87l.27-4.41s-3.38-.62-4.15-1.87S61,16.81,61.56,12.87,64,2.17,72.8,2.84,84.71,6.45,83.9,12.6,82.43,25.85,78.28,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M67.05,18,64.78,11.4c-6.29-2.27-8.43-6-1.61-9.5S79.22.16,83.5,3.51s3.76,8.64,2.41,14-6,10.57-6,10.57L74.41,30l-3.62-6.28c2.81-1.5,2.87-6.38,1.21-7.36A3.54,3.54,0,0,0,67.05,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26.92,64.5l-6-2.81c-.93-1.33-3.48-6.55-4.81-6.82A10.43,10.43,0,0,0,9.8,56.75C8.5,57.94,8.33,59,9,60a54,54,0,0,0,6.28,5.88c1.21.8,14.05,7.49,14.05,7.49l4.28-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M61.16,35.61l3.35-4.28S71,35.27,75.74,34s3-2.41,3-2.41l3.07,2.67c-2.94,4.42-7.92,4.38-12,3.21A86.68,86.68,0,0,0,61.16,35.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.09,40.43c-6.29-1.07-8.37,2.85-9.5,6.28S42.7,68.12,42.7,68.12c-4.94-1.08-13.51-4-15.38-4.55a3.84,3.84,0,0,0-4.68,2.27c-.94,2-1.74,4.68,0,5.75S36.28,78.82,41,80.15s9.13,3.37,11.5-1.47,8.29-17.39,9.9-23.94S63.32,42.18,58.09,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M99.3,62a3.52,3.52,0,0,0-3.19-.49L63.4,72.17A8.21,8.21,0,0,0,58,77.85L52.8,97.5a3,3,0,0,0,1,3.11c.76.64,3.19,2.68,3.94,3.33a3,3,0,0,0,2.92.58L94.73,93.45a7.19,7.19,0,0,0,4.7-4.94l5.22-19.31a3.56,3.56,0,0,0-1.16-3.68C102.77,64.92,100.15,62.61,99.3,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M62,81.19l-5.22,19.65a3,3,0,0,0,3.88,3.68L94.73,93.45a7.19,7.19,0,0,0,4.7-4.94l5.22-19.31a3.59,3.59,0,0,0-4.58-4.35L67.36,75.51A8.21,8.21,0,0,0,62,81.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "84.95 82.04 79.56 83.79 82.25 85.35 87.64 83.6 84.95 82.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "79.56 83.79 74.17 121.99 76.87 123.55 82.25 85.35 79.56 83.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "82.25 85.35 76.87 123.55 82.25 121.8 87.64 83.6 82.25 85.35"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("use", {
    width: 104.77,
    height: 156.36,
    xlinkHref: "#ManOnChair_01a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff6B);
export default __webpack_public_path__ + "static/media/staff-6-b.cc7795fc9932be931d10449410a3277d.svg";
export { ForwardRef as ReactComponent };